import "./src/css/global.css";
import "./src/styles/fonts.css";

export const onInitialClientRender = () => {
  import("flowbite").then((module) => {
    // Flowbite initialization code if necessary
  });
};
